import { Button, Stack, Typography } from "@mui/material";
import { MAINNET_BRIDGE } from "config/default";
import { BigNumber, ethers } from "ethers";
import { Deposit } from "modules/bridge/api/useBridges";
import { ClaimButton } from "modules/bridge/ClaimButton";
import { DESTINATION_NETWORK_BY_VALUE } from "modules/bridge/config";
import { decodeMetadata } from "modules/bridge/History";
import { Address } from "viem";
import PromIcon from "modules/bridge/config/assets/Prom.svg";

interface Props {
  canClime: boolean;
  returnTime: string;
  deposit: Deposit;
}

export const BridgeTransaction = ({ canClime, returnTime, deposit }: Props) => {
  const [_, tokenSymbol] = decodeMetadata(deposit.metadata) || ["", ""];
  return (
    <Stack
      sx={{
        background: "#FFFFFF",
        boxShadow: "2px 2px 10px 0px #1212120F",
        borderRadius: 3,
        padding: 7,
        flexDirection: "row",
        justifyContent: "space-between",
        marginBottom: 3,
        height: "100px",
        alignItems: "center",
      }}
    >
      <Stack gap={1}>
        <Stack gap={2} flexDirection="row">
          <Typography variant="highlight">Withdraw</Typography>
          <PromIcon />
          <Typography variant="body2" color="text.secondary">
            {ethers.utils.formatUnits(deposit.amount || "0")} {tokenSymbol}
          </Typography>
        </Stack>
        <Typography sx={{ display: { xs: "none", sm: "static" } }}>
          {canClime
            ? "Your assets are ready to claim"
            : `Awaiting for confirmation. This may take from 15m up to 1hr`}
        </Typography>

        <Typography sx={{ display: { xs: "static", sm: "none" } }}>
          {canClime ? "Your assets are ready to claim" : `Wait 5m-24hr`}
        </Typography>
      </Stack>
      {deposit.ready_for_claim && !deposit.claim_tx_hash ? (
        <ClaimButton
          amount={BigNumber.from(deposit.amount || "0")}
          depositCount={Number(deposit.deposit_cnt) || 0}
          depositTxHash={deposit.tx_hash}
          destinationAddress={deposit.dest_addr as Address}
          from={{
            networkId: deposit.orig_net,
            bridgeContractAddress: MAINNET_BRIDGE,
          }}
          to={{
            key: "",
            networkId: deposit.dest_net,
            bridgeContractAddress: MAINNET_BRIDGE,
          }}
          token={{
            address: deposit.orig_addr as Address,
            chainId:
              DESTINATION_NETWORK_BY_VALUE[
                deposit.orig_net as keyof typeof DESTINATION_NETWORK_BY_VALUE
              ].chain.id,
          }}
          tokenOriginNetwork={deposit.orig_net}
          globalIndex={Number(deposit.global_index)}
        />
      ) : (
        <Button
          target="_blank"
          href={
            deposit.dest_net === 1
              ? `https://eth.blockscout.com/tx/${deposit?.tx_hash}`
              : `https://prom-blockscout.eu-north-2.gateway.fm/tx/${deposit?.tx_hash}`
          }
          sx={{ width: "100px" }}
          variant="outlined"
        >
          View
        </Button>
      )}
    </Stack>
  );
};
